module.exports = __webpack_public_path__ + "static/media/background4.2b8faeac.jpg";